module.exports = __webpack_public_path__ + "static/vishal-mission-3c46daefecc5a5d6aaabcaab7b7d697e.jpg";